import * as types from 'modules/brands/actionsType';
import type { Brand } from 'modules/brands/types';
import type { Action } from 'modules/global/generic.types';
import { FETCH_GROUP_SUCCESS } from 'modules/groups/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

type BrandsByGroupIdState = Record<string, string[]>;

type GroupConfigPayload = {
  id: string;
  brandIds: string[];
  projectionType?: string;
};

const initialState: BrandsByGroupIdState = {};

const fetchBrandsByGroupSuccessReducer = (state: BrandsByGroupIdState, { payload }: { payload: { brands: Brand[]; groupId: string } }) => ({
  ...state,
  [payload.groupId]: payload.brands.map(brand => brand.id),
} as BrandsByGroupIdState);

const onGroupConfigFetchSuccess = {
  matcher: ({ type, payload }: Action) => type === FETCH_GROUP_SUCCESS && (payload as GroupConfigPayload)?.projectionType === 'config',
  reducer: (state: BrandsByGroupIdState, { payload: group }: { payload: GroupConfigPayload }) => ({
    ...state,
    [group.id]: group.brandIds,
  } as BrandsByGroupIdState),
};

export default createReducer<BrandsByGroupIdState>(
  initialState,
  {
    [types.FETCH_BRANDS_BY_GROUP_SUCCESS]: fetchBrandsByGroupSuccessReducer,
  },
  [onGroupConfigFetchSuccess]
);
